import { config } from "../config/config";
export const getYoutubeVideoIdFromUrl = (url) => {
    const regExp = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[1].length === 11 ? match[1] : null;
};
export const getYoutubePlaylistIdFromUrl = (url) => {
    const regExp = /[&|\?]list=([a-zA-Z0-9_-]+)/;
    const match = url.match(regExp);
    return match === null || match === void 0 ? void 0 : match[1];
};
export const buildYoutubeApiUrl = (url) => {
    return `${config.REACT_APP_YOUTUBE_API_BASE_URL}${url}&key=${config.REACT_APP_YOUTUBE_API_KEY}`;
};
export const getVideoByIdApiUrl = (id) => {
    return buildYoutubeApiUrl(`/videos?id=${id}&part=id,player,snippet,status`);
};
